export default __webpack_public_path__ + "static/media/Html5Icon.700ce76a.svg";